import { AUTH_TOKEN_KEY, UN_ACTIVE_TIMER_KEY } from './constanst';

export const clearAuthLocalData = () => {
  window.localStorage.removeItem(AUTH_TOKEN_KEY);
  window.localStorage.removeItem(UN_ACTIVE_TIMER_KEY);
};
